import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import ClaimAction from '../../entities/customercare/claimaction'
import Claim from '../../entities/customercare/claim'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ClaimActionState extends ListState<ClaimAction>{
    editModel: ClaimAction;
    claim: number;
    itemLoading: boolean;
}
class ClaimActionModule extends ListModule<ClaimActionState,any,ClaimAction>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<ClaimAction>(),
        loading: false,
        itemLoading: false,
        editModel: new ClaimAction(),
        activeList: new Array<ClaimAction>(),
        claim: 0,
        path: 'claim-actions'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        init(state: ClaimActionState, model: Claim) {
            state.editModel = Object.assign({});
            state.claim = 0;
            if (model != undefined) {
                state.claim = model.id;
            }
        },
        new(state: ClaimActionState, model: ClaimAction) {
            state.editModel = Object.assign({});
        },
    });
}
const claimactionModule=new ClaimActionModule();
export default claimactionModule;
